import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { NQHint } from "@visonum/network-quality-sdk";
import { getSdk } from "../../networkQuality";
import { AppThunk } from "../../store";
import * as R from "ramda";
import { logger } from "../../helper/logger";
import { selectLatestRecord } from "../history/selectLatestRecord";
import HintJson from "./components/HintJson";

export interface HintsState {
  hints: NQHint[],
  currentHintIndex: number;
  isExpanded: boolean;
}

const initialState: HintsState = {
  hints: [],
  currentHintIndex: 0,
  isExpanded: false,
}

export const initHints = (): AppThunk => (dispatch, getState) => {
  const lastRecord = selectLatestRecord(getState());
  const speedtestId = R.isNil(lastRecord) ? undefined : lastRecord.prepareResult.init.speedtest.id;
  const hintsObservable = getSdk().hints(speedtestId);

  hintsObservable.subscribe({
    next: (hints) => { dispatch(updateHints(hints)) },
    error: (err) => logger.debug(`initHints failed with`, err), // TODO: report to sentry
  });
};

export const hintSlice = createSlice({
  name: 'hints',
  initialState,
  reducers: {
    updateHints: (_, action: PayloadAction<NQHint[]>) => {
      return {
        hints: action.payload,
        currentHintIndex: 0,
        isExpanded: false,
      }
    },
    updateCurrentHintIndex: (state, action: PayloadAction<number>) => {
      state.currentHintIndex = action.payload;
      state.isExpanded = false;
    },    
    updateHintIsExpanded: (state, action: PayloadAction<boolean>) => {
      state.isExpanded = action.payload;
    },    
  }
});

export const prevIsEnabled = (state: HintsState, hints: HintJson[])=> hints.length > 0 && state.currentHintIndex > 0;

export const nextIsEnabled = (state: HintsState, hints: HintJson[])=> hints.length > 0 && state.currentHintIndex < (hints.length - 1);

export const { updateHints, updateCurrentHintIndex, updateHintIsExpanded } = hintSlice.actions;

export default hintSlice;